module.exports = __webpack_public_path__ + "static/media/aroma-bg.996efeb8.mp4";